const dict = {
  uk: {
    app: {
      brand: 'Lingvish Reader',
      backToProfile: 'Назад у профіль',
      signIn: 'Увійти',
      signInOrRegister: 'Увійти або зареєструватись',
      tabLockedPrompt: 'Ця вкладка доступна після реєстрації. Створіть акаунт, щоб зберігати книги, слова та прогрес.',
    },
    tabs: {
      library: 'Бібліотека',
      myBooks: 'Мої книги',
      dictionary: 'Словник',
      profile: 'Профіль',
    },
    library: {
      searchPlaceholder: 'Пошук книг...',
      allLevels: 'Усі',
      allGenres: 'Усі жанри',
      emptyNoBooks: 'Книг поки немає.',
      emptyNoResults: 'Нічого не знайдено.',
    },
    genres: {
      classic: 'Класика',
      adventure: 'Пригоди',
      mystery: 'Детектив',
      fantasy: 'Фентезі',
      children: 'Дитяча',
      short_story: 'Оповідання',
      romance: 'Романтика',
      horror: 'Жахи',
      sci_fi: 'Наук. фантастика',
      drama: 'Драма',
      nonfiction: 'Нон-фікшн',
    },
    bookCard: {
      processing: 'Обробляється…',
    },
    bookDetail: {
      notFound: 'Книгу не знайдено',
      continue: 'Продовжити',
      read: 'Читати',
      preview: 'Перегляд',
      processing: 'Обробляється…',
      loginToLike: 'Увійдіть, щоб додати до вподобаних',
      removeFromLiked: 'Прибрати з вподобаних',
      addToLiked: 'Додати до вподобаних',
      previewOnlyBanner: 'Доступний лише короткий перегляд. Щоб читати книгу повністю, увійдіть або зареєструйтесь.',
      annotation: 'Анотація',
      bookmarks: 'Закладинки',
      removeBookmark: 'Прибрати закладинку',
      chapters: 'Розділи',
      chapterShort: 'розд.',
      chapterPrefix: 'Розділ {{num}}',
      words: 'слів',
    },
    reading: {
      back: 'Назад',
      backToBook: 'До книги',
      chapterList: 'Список розділів',
      previewMode: 'Перегляд',
      chapterLabel: 'Розділ {{num}}',
      chapterLabelWithTitle: 'Розділ {{num}}: {{title}}',
      previous: 'Попередній',
      next: 'Наступний',
      end: 'Кінець',
      loadFailed: 'Не вдалося завантажити розділ',
      previewTitle: 'Це лише перегляд',
      previewMessage: 'Щоб читати книгу повністю, зберігати прогрес і додавати слова у словник — увійдіть або зареєструйтесь. Це безкоштовно.',
      chaptersModalTitle: 'Розділи',
      closeAria: 'Закрити',
      inVocab: 'У словнику',
    },
    wordPopover: {
      listen: 'Прослухати',
      translateSentence: 'Перекласти речення',
      removeBookmark: 'Прибрати закладинку',
      bookmarkHere: 'Залишити закладинку тут',
      noTranslation: 'Переклад поки недоступний.',
      loginToAdd: 'Увійти, щоб додати',
      removeFromVocab: 'Видалити зі словника',
      addedToVocab: 'Додано у словник',
      addToVocab: 'Додати у словник',
    },
    sentencePopover: {
      removeBookmark: 'Прибрати закладинку',
      bookmarkHere: 'Залишити закладинку тут',
      listen: 'Прослухати',
      translating: 'Перекладаю…',
      translateFailed: 'Не вдалося перекласти речення.',
    },
    dictionary: {
      emptyTitle: 'Словник порожній',
      emptyMessage: 'Тапніть на слово під час читання і натисніть "Додати у словник" — воно з\'явиться тут.',
      cards: 'Картки',
      test: 'Тест',
      dueForReview: '{{count}} на повторення',
      allReviewed: 'Усі повторено',
      questionsCount: '10 запитань',
      noBook: 'Без книги',
      noChapter: 'Без розділу',
      chapterPrefix: 'Розділ {{num}}',
      noTranslation: 'переклад відсутній',
      listen: 'Прослухати',
      remove: 'Видалити',
      confirmRemove: 'Видалити "{{word}}"?',
    },
    flashcards: {
      noWords: 'Немає слів для повторення.',
      done: 'Готово!',
      knewCount: 'Знали: {{correct}} з {{total}} ({{pct}}%)',
      missedCount: 'Не вгадали: {{wrong}}',
      restart: 'Ще раз',
      finish: 'Завершити',
      tapForTranslation: 'Тапніть, щоб побачити переклад',
      tapToFlipBack: 'Тапніть, щоб повернутися',
      noTranslation: 'переклад відсутній',
      didNotKnow: 'Не знав',
      knew: 'Знав',
    },
    test: {
      notEnoughWords: 'Потрібно мати щонайменше кілька слів із перекладами для тестування.',
      correctOfTotal: '{{correct}} правильних з {{total}}',
      restart: 'Ще раз',
      finish: 'Завершити',
      pickTranslation: 'Виберіть переклад:',
      next: 'Далі',
    },
    myBooks: {
      all: 'Усі',
      inProgress: 'Читаю',
      liked: 'Вподобані',
      completed: 'Прочитані',
      empty: 'Поки нічого тут немає.',
    },
    profile: {
      defaultName: 'Користувач',
      brand: 'Lingvish Reader',
      currentlyReading: 'Зараз читаєте',
      chapterPrefix: 'Розділ {{num}}',
      booksSection: 'Книги',
      dictionarySection: 'Словник',
      statCompleted: 'Прочитано',
      statInProgress: 'У процесі',
      statLiked: 'Вподобані',
      statVocabTotal: 'Усі слова',
      statVocabLearning: 'Вчу',
      statVocabMastered: 'Вивчено',
      backToProfile: 'Повернутись на профіль',
      signOutDevice: 'Вийти з Reader на цьому пристрої',
      signingOut: 'Вихід…',
      confirmSignOut: 'Вийти з Reader на цьому пристрої? Доведеться залогінитись знову, щоб увійти.',
    },
    install: {
      title: 'Встановити Reader на телефон',
      subtitle: 'Іконка на головному екрані, повноекранний режим, оффлайн-читання',
      install: 'Встановити',
      how: 'Як',
      hide: 'Сховати',
      iosStep1: 'Тапніть значок «Поділитися» внизу Safari (квадрат зі стрілкою ↑)',
      iosStep2: 'У меню знайдіть пункт «На Початковий екран» (з іконкою ⊕). Може знадобитися гортати трохи вниз',
      iosStep3: 'У вікні попереднього перегляду натисніть «Додати» у правому верхньому куті',
      iosStep4: 'Іконка «Reader» з\'явиться на головному екрані телефона',
    },
  },
  en: {
    app: {
      brand: 'Lingvish Reader',
      backToProfile: 'Back to profile',
      signIn: 'Sign in',
      signInOrRegister: 'Sign in or register',
      tabLockedPrompt: 'This tab is available after signing up. Create an account to save books, words, and progress.',
    },
    tabs: {
      library: 'Library',
      myBooks: 'My books',
      dictionary: 'Vocabulary',
      profile: 'Profile',
    },
    library: {
      searchPlaceholder: 'Search books...',
      allLevels: 'All',
      allGenres: 'All genres',
      emptyNoBooks: 'No books yet.',
      emptyNoResults: 'Nothing found.',
    },
    genres: {
      classic: 'Classic',
      adventure: 'Adventure',
      mystery: 'Mystery',
      fantasy: 'Fantasy',
      children: 'Children',
      short_story: 'Short story',
      romance: 'Romance',
      horror: 'Horror',
      sci_fi: 'Sci-Fi',
      drama: 'Drama',
      nonfiction: 'Non-fiction',
    },
    bookCard: {
      processing: 'Processing…',
    },
    bookDetail: {
      notFound: 'Book not found',
      continue: 'Continue',
      read: 'Read',
      preview: 'Preview',
      processing: 'Processing…',
      loginToLike: 'Sign in to add to favorites',
      removeFromLiked: 'Remove from favorites',
      addToLiked: 'Add to favorites',
      previewOnlyBanner: 'Only a short preview is available. To read the full book, sign in or register.',
      annotation: 'Annotation',
      bookmarks: 'Bookmarks',
      removeBookmark: 'Remove bookmark',
      chapters: 'Chapters',
      chapterShort: 'ch.',
      chapterPrefix: 'Chapter {{num}}',
      words: 'words',
    },
    reading: {
      back: 'Back',
      backToBook: 'To book',
      chapterList: 'Chapter list',
      previewMode: 'Preview',
      chapterLabel: 'Chapter {{num}}',
      chapterLabelWithTitle: 'Chapter {{num}}: {{title}}',
      previous: 'Previous',
      next: 'Next',
      end: 'The end',
      loadFailed: 'Failed to load chapter',
      previewTitle: 'This is just a preview',
      previewMessage: 'To read the full book, save progress, and add words to your vocabulary — sign in or register. It\'s free.',
      chaptersModalTitle: 'Chapters',
      closeAria: 'Close',
      inVocab: 'In vocabulary',
    },
    wordPopover: {
      listen: 'Listen',
      translateSentence: 'Translate sentence',
      removeBookmark: 'Remove bookmark',
      bookmarkHere: 'Bookmark here',
      noTranslation: 'Translation not available yet.',
      loginToAdd: 'Sign in to add',
      removeFromVocab: 'Remove from vocabulary',
      addedToVocab: 'Added to vocabulary',
      addToVocab: 'Add to vocabulary',
    },
    sentencePopover: {
      removeBookmark: 'Remove bookmark',
      bookmarkHere: 'Bookmark here',
      listen: 'Listen',
      translating: 'Translating…',
      translateFailed: 'Could not translate the sentence.',
    },
    dictionary: {
      emptyTitle: 'Vocabulary is empty',
      emptyMessage: 'Tap a word while reading and press "Add to vocabulary" — it will appear here.',
      cards: 'Flashcards',
      test: 'Test',
      dueForReview: '{{count}} to review',
      allReviewed: 'All reviewed',
      questionsCount: '10 questions',
      noBook: 'No book',
      noChapter: 'No chapter',
      chapterPrefix: 'Chapter {{num}}',
      noTranslation: 'no translation',
      listen: 'Listen',
      remove: 'Remove',
      confirmRemove: 'Remove "{{word}}"?',
    },
    flashcards: {
      noWords: 'No words to review.',
      done: 'Done!',
      knewCount: 'Knew: {{correct}} of {{total}} ({{pct}}%)',
      missedCount: 'Missed: {{wrong}}',
      restart: 'Again',
      finish: 'Finish',
      tapForTranslation: 'Tap to see translation',
      tapToFlipBack: 'Tap to flip back',
      noTranslation: 'no translation',
      didNotKnow: 'Didn\'t know',
      knew: 'Knew it',
    },
    test: {
      notEnoughWords: 'You need at least a few words with translations to take the test.',
      correctOfTotal: '{{correct}} correct out of {{total}}',
      restart: 'Again',
      finish: 'Finish',
      pickTranslation: 'Pick the translation:',
      next: 'Next',
    },
    myBooks: {
      all: 'All',
      inProgress: 'Reading',
      liked: 'Favorites',
      completed: 'Finished',
      empty: 'Nothing here yet.',
    },
    profile: {
      defaultName: 'User',
      brand: 'Lingvish Reader',
      currentlyReading: 'Currently reading',
      chapterPrefix: 'Chapter {{num}}',
      booksSection: 'Books',
      dictionarySection: 'Vocabulary',
      statCompleted: 'Finished',
      statInProgress: 'In progress',
      statLiked: 'Favorites',
      statVocabTotal: 'All words',
      statVocabLearning: 'Learning',
      statVocabMastered: 'Mastered',
      backToProfile: 'Back to profile',
      signOutDevice: 'Sign out of Reader on this device',
      signingOut: 'Signing out…',
      confirmSignOut: 'Sign out of Reader on this device? You\'ll need to log in again to get back in.',
    },
    install: {
      title: 'Install Reader on your phone',
      subtitle: 'Icon on home screen, full-screen mode, offline reading',
      install: 'Install',
      how: 'How',
      hide: 'Hide',
      iosStep1: 'Tap the Share icon at the bottom of Safari (square with an up arrow ↑)',
      iosStep2: 'Find "Add to Home Screen" (with the ⊕ icon) in the menu. You may need to scroll a bit',
      iosStep3: 'In the preview window, tap "Add" in the top-right corner',
      iosStep4: 'The "Reader" icon will appear on your phone\'s home screen',
    },
  },
};

export default dict;
